export default __webpack_public_path__ + "static/media/category_26.2d854aa0.png";